module.exports = __webpack_public_path__ + "img/20250909171246291.a46e03bb.jpg";